import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import NavHeader from './navheader'
import Footer from './footer'
import SubMenu from './submenu'
import Lightbox from 'react-images';
import MetaTags from 'react-meta-tags'

class Faq extends Component {

    constructor() {
        super();
        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
    }

    state = {
        lightboxIsOpen: false
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    openLightbox(event, obj) {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        });

    }
    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }

    render() {
        // console.log('metatag')
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    <MetaTags>
                        <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                        <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                        <meta property="og:url" content={window.location.href} />
                        <meta property="og:image" content={'imgsrc'} />
                        <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                        <meta property="og:type" content='website' />
                        <meta property="fb:pages" content="129193147647837" />
                    </MetaTags>
                    <div className='container'>
                        <div className="row">
                            <Col style={{ paddingLeft: 50 }}>
                                <h2>คำถามที่พบบ่อย</h2>
                            </Col>
                        </div>
                    </div>
                    <div className='container'>

                        <Row style={{ padding: 20 }}>
                            <Col style={{ backgroundColor: '#fafafa', padding: 10 }}>
                                <h3><strong>รายละเอียดการโอนเงิน</strong></h3>
                                <h4 style={{ color: '#f57224 !important', marginTop: 20, marginBottom: 20, textAlign: 'center' }}>"รอการติดต่อกลับจากเราอีกครั้ง ก่อนทำการโอนเงิน"</h4>
                                <h4>1. รอการยืนยันยอดเงินทั้งหมดจากเจ้าหน้าที่</h4>
                                <h5 style={{ color: '#898989' }}>ยอดชำระที่ท่านเห็นในหน้าก่อนนี้ อาจจะไม่ใช่ยอดสุดท้าย เนื่องจากสินค้าอาจมีการเปลี่ยนแปลงน้ำหนัก หรือมีการแกว่งของน้ำหนัก ทำให้ท่านต้องรอการยืนยันยอดจากเจ้าหน้าที่ส่งสด</h5>
                                <br />
                                <h4>2. โอนเงิน</h4>
                                <h5 style={{ color: '#898989' }}>กดที่ภาพเพื่อขยาย</h5>
                                {/* <h5 style={{ color: '#898989' }}>ธนาคารกสิกรไทย</h5>
                                <h5 style={{ color: '#898989' }}>ชื่อบัญชี นายอริย ธรรมวัฒนะ</h5>
                                <h5 style={{ color: '#898989' }}>บัญชีออมทรัพย์ เลขที่บัญชี 027-1-74892-2</h5> */}
                                <div className='hidden-sm hidden-md hidden-lg'>
                                    <Lightbox
                                        images={[{ src: "../../static/images/bankaccountmobile.jpg" }]}
                                        isOpen={this.state.lightboxIsOpen}
                                        onClose={this.closeLightbox}
                                        backdropClosesModal={true}
                                        width={1024}
                                    />
                                    <img className="img"
                                        onClick={this.openLightbox}
                                        style={{ width: '100%', cursor: 'pointer' }}
                                        src="../../static/images/bankaccountmobile.jpg" />
                                </div>
                                <div className='hidden-xs'>
                                    <Lightbox
                                        images={[{ src: "../../static/images/bankaccountmobile.jpg" }]}
                                        isOpen={this.state.lightboxIsOpen}
                                        onClose={this.closeLightbox}
                                        backdropClosesModal={true}
                                        width={1024}
                                    />
                                    <img className="img"
                                        onClick={this.openLightbox}
                                        style={{ width: '50%', cursor: 'pointer' }}
                                        src="../../static/images/bankaccountmobile.jpg" />
                                </div>
                                {/* <div className='hidden-sm hidden-md hidden-lg'>
                                    <img style={{ width: '120%', marginLeft: '-10%' }} src="../../static/images/bankaccount.jpg" />
                                </div>
                                <div className='hidden-xs'>
                                    <img style={{ width: '50%' }} src="../../static/images/bankaccount.jpg" />
                                </div> */}
                                {/* <div>
                                    <div style={{ display: 'inline-block', verticalAlign: 'top', paddingLeft: 15, paddingRight: 15, paddingTop: 14, marginRight: 4 }}><img style={{ width: 50 }} src="../../static/images/logo_scb.png" /></div>
                                    <div style={{ display: 'inline-block' }}>
                                        <h5 style={{ color: '#898989' }}>ธนาคารไทยพาณิชย์ จำกัด (มหาชน)</h5>
                                        <h5 style={{ color: '#898989' }}>ชื่อบัญชี บริษัท ยิ่งเจริญ เฟรชเมท จำกัด</h5>
                                        <h5 style={{ color: '#898989' }}>เลขที่บัญชี 181-262561-0</h5>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ display: 'inline-block', paddingLeft: 4, verticalAlign:'top', paddingTop:18 }}>
                                        <img style={{ width: 70, marginRight: 7 }} src="../../static/images/promptpay.jpg" />
                                    </div>
                                    <div style={{ display: 'inline-block' }}>
                                        <h5 style={{ color: '#898989', paddingTop:0 }}>บัญชีนี้ สามารถใช้บริการ พร้อมเพย์ (PromptPay) ได้</h5>
                                        <h5 style={{ color: '#898989' }}>เลขประจำตัวผู้เสียภาษี: 0105560180717</h5>
                                    </div>
                                </div> */}
                                <br />
                                <h4>3. แอดไลน์ @songsod เพื่อส่งสลิปโอนเงินได้เลย</h4>
                                <div><img style={{ minWidth: 70 }} src='../static/images/SongSodChat.png' /></div>
                                <h5 style={{ color: '#898989' }}>แอดไลน์ <a href="https://line.me/R/ti/p/%40songsod" target="_blank">@songsod</a> เพื่อส่งสลิปโอนเงินได้เลย พร้อมแจ้งชื่อให้กับพนักงาน</h5>
                            </Col>
                        </Row>

                        <Row style={{ padding: 20 }}>
                            <Col style={{ backgroundColor: '#fafafa', padding: 10 }}>
                                <h4>ด้านคุณภาพ</h4>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : ซื้อของมาจากไหน ตรวจสอบแหล่งที่มาได้หรือไม่?</h5>
                                <h5 style={{ color: '#898989' }}>A : สินค้าของส่งสดเป็นสินค้าที่มาจากตลาดยิ่งเจริญ ซึ่งเป็นตลาดที่ได้รับการการันตีจากสถาบันต่างๆมากมายว่าปลอดภัย และสะอาด</h5>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : จะมั่นใจได้อย่างไรว่า ของจะไม่สอดไส้</h5>
                                <h5 style={{ color: '#898989' }}>A : ส่งสดไม่ได้ซื้อจากแม่ค้าโดยตรง แต่จะมีผู้ซื้อส่วนตัวไปเลือกให้ ซึ่งถูกฝึกฝนการเลือกสินค้าที่มีคุณภาพมาเป็นอย่างดี</h5>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : ถ้าของไม่ดี เน่าเสีย จะทำอย่างไร</h5>
                                <h5 style={{ color: '#898989' }}>A : ทางส่งสดจะทำการคืนค่าสินค้าให้กับลูกค้าเมื่อตรวจสอบว่าของไม่ดี หรือเน่าเสีย</h5>
                            </Col>
                        </Row>

                        <Row style={{ padding: 20 }}>
                            <Col style={{ backgroundColor: '#fafafa', padding: 10 }}>
                                <h4>ลูกค้าธุรกิจ</h4>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : หากต้องการสั่งสินค้าในจำนวนมากสามารถติดต่อได้ที่อย่างไรบ้าง</h5>
                                <h5 style={{ color: '#898989' }}>A : ท่านสามารถติดต่อเจ้าหน้าที่ส่งสดได้ที่ Line :@songsod เพื่อสอบถามรายละเอียดเกี่ยวกับลูกค้าธุรกิจ</h5>
                            </Col>
                        </Row>

                        <Row style={{ padding: 20 }}>
                            <Col style={{ backgroundColor: '#fafafa', padding: 10 }}>
                                <h4>ด้านการบริการ</h4>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : จัดส่งอย่างไร</h5>
                                <h5 style={{ color: '#898989' }}>A : จัดส่งด้วยมอเตอร์ไซค์ ภายใน 1-2 ชั่วโมง ภายหลังจากการยืนยันคำสั่งซื้อ</h5>
                                <p>เวลาที่ใช้ในการจัดส่งอาจเปลี่ยนแปลงตามปริมาณการสั่งซื้อ สินค้าที่สั่งซื้อ เส้นทาง และสภาพการจราจร
โดยการจัดส่งต่อรอบนั้นเราจัดส่งด้วยบริการขนส่ง Lalamove ประเภทมอเตอร์ไซค์เพื่อความรวดเร็ว โดยจะมีข้อจำกัดในด้านน้ำหนัก คือไม่เกิน 20 กิโลกรัม หรือ สินค้ามีขนาดใหญ่เกินกว่าจะจัดส่งด้วยมอเตอร์ไซค์
ในกรณีที่รถมอเตอร์ไซค์ 1 คันไม่สามารถขนส่งสินค้าทั้งหมดได้ อาจจะจัดส่งโดยการแบ่งเป็นหลายรอบ ซึ่งทำให้มีค่าบริการขนส่งที่เพิ่มขึ้น</p>
                                <br />

                                <h5 style={{ color: '#898989' }}>Q : สินค้าจะถูกบรรจุมาอย่างไร</h5>
                                <h5 style={{ color: '#898989' }}>A : ผู้คัดสรรสินค้าส่วนตัวจะทำการบรรจุสินค้าในหีบห่อที่จะรักษาสภาพของสินค้าได้ดีที่สุดเมื่อสินค้าถึงมือของท่าน เช่นการบรรจุในถุงที่มีน้ำแข็งเพื่อรักษาความสด หรือการห่อผักด้วยกระดาษ โดยไบริการนี้ไม่มีค่าใช้จ่ายเพิ่มเติม</h5>
                            </Col>
                        </Row>

                        <Row style={{ padding: 20 }}>
                            <Col style={{ backgroundColor: '#fafafa', padding: 10 }}>
                                <h4>เวลาเปิด - ปิด</h4>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : เวลาเปิด-ปิด กี่โมง</h5>
                                <h5 style={{ color: '#898989' }}>A : ส่งสด เปิดทำการตั้งแต่เวลา 9:00 - 17:00 น. โดยที่ท่านสามารถเลือกสินค้าได้ตลอดเวลา และสามารถเลือกช่วงเวลาจัดส่ง - รับสินค้าตามตารางที่ทางส่งสดได้กำหนดไว้</h5>
                            </Col>
                        </Row>

                        <Row style={{ padding: 20 }}>
                            <Col style={{ backgroundColor: '#fafafa', padding: 10 }}>
                                <h4>การชำระเงิน</h4>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : ชำระเงินอย่างไร</h5>
                                <h5 style={{ color: '#898989' }}>A : ท่านสามารถเลือกช่องทางการชำระเงินได้ 2 ช่องทาง คือการโอนเงิน และการชำระเงินที่ปลายทาง</h5>
                                <br />
                                {/* <h5>ชำระเงินปลายทาง</h5>
                                <p>พนักงานขนส่งจะทำการแจ้งยอดที่ท่านต้องชำระ และ ท่านสามารถชำระที่พนักงานส่งของได้ทันที
โดยจะการชำระเงินปลายทางจะจำกัดยอดซื้อทั้งหมด(รวมค่าขนส่ง) จะต้องไม่เกิน 1,000 บาท</p> */}
                                <br />
                                <h5>ชำระเงินด้วยการโอน มีขั้นตอนดังนี้</h5>
                                <p>1. โอนเงินมาที่บัญชี ตามจำนวนที่พนักงานส่งสดได้แจ้งให้ท่านทราบ</p>
                                <p>2. ส่งหลักฐานการชำระเงินมาที่ Line @songsod</p>
                                <p>3. รอการยืนยันจากพนักงาน</p>
                                <p>โปรดตรวจสอบเลขที่บัญชีในการโอนเงิน เฉพาะที่ได้แสดงไว้บนเว็บไซต์ของ ส่งสด.com เท่านั้น ในกรณีที่ท่านได้รับโทรศัพท์ให้โอนเงินไปยังบัญชีอื่นที่ไม่ได้ระบุบนเว็บไซต์นี้ กรุณาใช้ความระมัดระวัง และอย่าโอนเงิน เนื่องจากอาจเป็นมิจฉาชีพได้ ท่านสามารถแจ้งมายังช่องแชท หรือ Line : @songsod</p>
                            </Col>
                        </Row>

                        <Row style={{ padding: 20 }}>
                            <Col style={{ backgroundColor: '#fafafa', padding: 10 }}>
                                <h4>ด้านการใช้งาน</h4>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : เพราะเหตุใด จึงต้องรอการสรุปรายการจากทีมงานส่งสดอีกครั้ง</h5>
                                <h5 style={{ color: '#898989' }}>A : เนื่องจากเมื่อท่านได้สรุปรายการสั่งซื้อบนหน้าเว็บไซต์ ทางทีมงานผู้คัดสรรส่วนตัว (personal shopper) ของ ส่งสด.com จะทำการตรวจสอบสินค้าในตลาด ว่ามีสินค้าที่ท่านต้องการ ที่มีสภาพที่ดีเพียงพอที่จะจัดส่งให้ท่านหรือไม่ นอกจากนี้ สินค้าบางชนิดอาจมีปริมาณหรือน้ำหนักที่ไม่ตรงพอดีกับปริมาณที่ท่านต้องการ เช่น ปลา หรือสินค้าสดที่มีการขายเป็นชิ้น แต่คิดราคาด้วยหน่วยกิโลกรัม ดังนั้นเพื่อป้องกันการคลาดเคลื่อนของราคา และปริมาณ ให้ท่านมั่นใจได้ว่า เราจะจัดส่งสินค้าท่านภาพ ได้ถูกต้องตรงตามเงินที่ท่านจ่าย เราจึงจะโทรศัพท์เพื่อสรุปรายการขาย และแจ้งให้ท่านทราบอีกครั้ง</h5>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : ทีมงานส่งสด จะติดต่อกลับเพื่อสรุปคำสั่งซื้อทันทีหรือไม่</h5>
                                <h5 style={{ color: '#898989' }}>A : เมื่อท่านได้ทำการสรุปคำสั่งซื้อบนหน้าเว็บไซต์แล้ว ทีมงานผู้คัดสรรส่วนตัว (personal shopper) ของส่งสด.com จะโทรศัพท์ติดต่อท่านโดยใช้หมายเลขโทรศัพท์ที่ท่านใช้สมัครใช้งาน ประมาณ 1-2 ชั่วโมงก่อนที่จะมีการจัดส่งสินค้าตามรอบเวลาที่ท่านได้เลือกไว้ เพื่อสรุปรายการสั่งซื้ออีกครั้ง
ในกรณีที่ท่านต้องการให้จัดส่งทันที ทางทีมงานผู้คัดสรรส่วนตัว จะติดต่อท่านกลับไปภายใน 20 นาที หลังจากที่ท่านสรุปคำสั่งซื้อบนหน้าเว็บไซต์</h5>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : หากต้องการให้จัดส่งทันที จะใช้เวลานานเท่าไร</h5>
                                <h5 style={{ color: '#898989' }}>A : การจัดส่งสินค้าทันที ใช้เวลาประมาณ 60 – 180 นาที หลังจากที่ท่านสรุปรายการสั่งซื้อบนหน้าเว็บไซต์ ทั้งนี้ ขึ้นอยู่กับปริมาณการสั่งซื้อ สินค้าที่ท่านสั่งซื้อ ช่องทางการชำระเงิน ระยะทางในการจัดส่ง และสภาพการจราจร โดยทีมงาน ส่งสด.com มีความพยายามอย่างสูงที่สุด ที่จะดำเนินการจัดหาสินค้าที่ท่านต้องการ ในท่านภาพ และจัดส่งให้ถึงท่านอย่างรวดเร็วที่สุด
ทีมงานผู้คัดสรรส่วนตัว (personal shopper) ของส่งสด.com จะโทรศัพท์ติดต่อท่านโดยใช้หมายเลขโทรศัพท์ที่ท่านใช้สมัครใช้งาน เพื่อสรุปคำสั่งซื้ออีกครั้ง และจะแจ้งระยะเวลาในการจัดส่งสินค้าให้ท่านทราบ</h5>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : สามารถสั่งจองสินค้าล่วงหน้าได้หรือไม่</h5>
                                <h5 style={{ color: '#898989' }}>A : ท่านสามารถสั่งจองล่วงหน้าได้หนึ่งวัน โดยท่านสามารถเลือกช่วงเวลาในการจัดส่งที่ท่านต้องการได้ และทีมงานผู้คัดสรรส่วนตัว (personal shopper) ของส่งสด.com จะโทรศัพท์ติดต่อท่านโดยใช้หมายเลขโทรศัพท์ที่ท่านใช้สมัครใช้งาน ประมาณ 1-2 ชั่วโมงก่อนที่จะมีการจัดส่งสินค้าตามรอบเวลาที่ท่านได้เลือกไว้ เพื่อสรุปรายการสั่งซื้ออีกครั้ง</h5>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : ควรทำอย่างไรหากพลาดการรับโทรศัพท์จากทีมงาน ส่งสด.com</h5>
                                <h5 style={{ color: '#898989' }}>A : ในกรณีที่ท่านไม่ได้รับสายที่ติดต่อจากทีมงาน ส่งสด.com ท่านสามารถโทรศัพท์เพื่อติดต่อกลับไปยังทีมงานได้</h5>
                                <p>สำหรับกรณีที่ท่านพลาดการรับสายโทรศัพท์จากทีมงาน ส่งสด.com เกิน 3 สาย หรือเกิน 10 นาทีหลังจากโทรศัพท์สายแรก เราขออนุญาติสงวนสิทธิ์ในการพักการให้บริการแก่ท่าน เพื่อให้บริการให้กับลูกค้าท่านอื่นก่อน โดยเมื่อท่านติดต่อกลับ เราจะทำการนำคำสั่งซื้อของท่านมาเข้าคิวให้บริการใหม่ เพื่อดำเนินการสั่งซื้อให้ท่านต่อไป ซึ่งอาจทำให้เวลาในการจัดส่งของคำสั่งซื้อของท่าน ยาวนานขึ้น</p>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : ทำอย่างไรหากเกิดปัญหาการให้บริการ</h5>
                                <h5 style={{ color: '#898989' }}>A : ในกรณีที่ท่านประสบปัญหาในการให้บริการ หรือต้องการสอบถามเพิ่มเติม หรือแนะนำบริการ เช่น ได้รับสินค้าล่าช้า หรือได้รับสินค้าไม่ตรงกับที่ท่านต้องการ ท่านสามารถติดต่อมายังช่องแชท หรือ line: @songsod โดยเรามีทีมงานตอบคำถามของท่าน ระหว่างเวลา 9:00-17:00 น.ทุกวัน</h5>
                                <br />
                                <h5 style={{ color: '#898989' }}>Q : สามารถยกเลิกคำสั่งซื้อได้หรือไม่</h5>
                                <h5 style={{ color: '#898989' }}>A : หลังจากท่านได้ทำการสรุปรายการสั่งซื้อบนหน้าเว็บไซต์เรียบร้อยแล้ว ท่านยังสามรถยกเลิกคำสั่งซื้อได้ จนกว่าที่ท่านจะยืนยันคำสั่งซื้อทางโทรศัพท์กับเจ้าหน้าที่ผู้คัดสรรส่วนตัว (personal shopper) ของ ส่งสด.com เพื่อดำเนินการจัดส่ง ซึ่งหลังจากที่ท่านยืนยันคำสั่งซื้อแล้ว ท่านจะไม่สามารถยกเลิกคำสั่งซื้อได้</h5>
                                <br />
                            </Col>
                        </Row>

                        <Row style={{ padding: 20 }}>
                            <Col style={{ backgroundColor: '#fafafa', padding: 10 }}>
                                <h3 style={{ textAlign: 'center' }}>หากต้องการติดต่อเพิ่มเติมสามารถติดต่อเข้ามาได้ที่ Line : @songsod ทางเรามีความยินดีรับคำแนะนำ ติชม หรือข้อสงสัยของท่าน</h3>
                            </Col>
                        </Row>

                    </div>
                </div>
                <Footer history={this.props.history} />
            </div>
        )
    }
}

export default Faq


// WEBPACK FOOTER //
// ./src/components/faq.js